// Domestic Helper Insurance Policy Constants and Data
import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Domestic Helper-specific action type constants
export const CANCEL_POLICY_DOMESTIC_HELPER = "CANCEL_POLICY_DOMESTIC_HELPER";

// Domestic Helper Policy Overview Data
export const domesticHelperPolicyOverview = {
  policyInfo: {
    policy_label: "Your Domestic Helper Policy",
    policy_label_ar: "وثيقة تأمين العاملة المنزلية",
    status: "Active",
    status_ar: "نشيط",
    planName: "Domestic Helper Insurance Policy",
    planName_ar: "وثيقة تأمين العاملة المنزلية",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
  cards: [
    {
      icon: "",
      value: "24/7 Support",
      value_ar: "دعم على مدار الساعة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Helper Coverage",
      value_ar: "تغطية العاملة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Claim Support",
      value_ar: "دعم المطالبات",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    }
  ]
};

// Domestic Helper Policy Manage Actions (only Cancel Policy)
export const manageDomesticHelperPolicy = {
  cards: [
    {
      icon: cancelPolicy,
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      type: CANCEL_POLICY_DOMESTIC_HELPER
    }
  ]
};

// Domestic Helper Benefits
export const domesticHelperBenefits = [
  "Medical Coverage for Helper",
  "Repatriation Coverage",
  "Third Party Liability",
  "Personal Accident Coverage",
  "24/7 Support Services"
];

// Function to filter cards for domestic helper (only cancel policy)
export const getFilteredDomesticHelperCards = (policyDetails) => {
  return manageDomesticHelperPolicy.cards;
};